import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-nice-card',
  templateUrl: './nice-card.component.html',
  styleUrls: ['./nice-card.component.scss'],
})
export class NiceCardComponent {}
